<router-outlet></router-outlet>
<ngx-spinner
  bdOpacity="0.5"
  zIndex="999999999"
  bdColor="rgba(51,51,51,0.86)"
  size="large"
  color="#fff"
  type="timer"
  [fullScreen]="true">
</ngx-spinner>
